import { ActionTypes } from 'store/constants';

export const listTranslationPracticeFail = (returnedPayload) => ({
  type: ActionTypes.translationPractice.listTranslationPracticeFail,
  payload: returnedPayload,
});

export const listTranslationPracticeSuccess = (returnedPayload) => ({
  type: ActionTypes.translationPractice.listTranslationPracticeSuccess,
  payload: returnedPayload,
});

export const deleteTranslationPractice = () => ({
  type: ActionTypes.translationPractice.deleteTranslationPractice,
});

export const deleteTranslationPracticeFail = (returnedPayload) => ({
  type: ActionTypes.translationPractice.deleteTranslationPracticeFail,
  payload: returnedPayload,
});

export const deleteTranslationPracticeSuccess = (returnedPayload) => ({
  type: ActionTypes.translationPractice.deleteTranslationPracticeSuccess,
  payload: returnedPayload,
});

export const updateTranslationPracticeSuccess = (returnedPayload) => ({
  type: ActionTypes.translationPractice.updateTranslationPracticeSuccess,
  payload: returnedPayload,
});

export const updateTranslationPracticeFail = (returnedPayload) => ({
  type: ActionTypes.translationPractice.updateTranslationPracticeFail,
  payload: returnedPayload,
});
